module.exports = __webpack_public_path__ + "img/launching-soon.6a0dcd36.png";